import styled from "styled-components";
export const Image = styled.img`
    display: block;
    margin-right: auto;
    margin-left: 0;
    width: 20%;
`;